import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  InputAdornment,
  CircularProgress,
} from "@mui/material";

const ModalFormPlan = ({
  type,
  handleSubmit,
  handleCloseModal,
  handleInputChange,
  data,
  isDisabled,
  formError,
  loading,
}) => {
  return (
    <>
      <Box
        sx={{
          maxWidth: "100%",
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 1,
          overflow: "auto",
        }}
      >
        <Typography variant="h6" gutterBottom>
          {type === "add" ? "Add Plan" : "Edit Plan"}
        </Typography>
        <form>
          <TextField
            label="Plan Name"
            name="name"
            value={data?.formData?.name || ""}
            onChange={(e) => handleInputChange("name", e.target.value)}
            error={!!formError?.name}
            helperText={formError?.name}
            fullWidth
            required
            margin="normal"
          />
          <TextField
            label="Price Per Qty"
            name="pricePerQty"
            type="number"
            disabled={
              type === "edit" ||
              (data?.formData?.planType === "complimentary" && true)
            }
            value={data?.formData?.pricePerQty || ""}
            onChange={(e) => handleInputChange("pricePerQty", e.target.value)}
            error={!!formError?.pricePerQty}
            helperText={formError?.pricePerQty}
            fullWidth
            required
            margin="normal"
            inputProps={{ min: 0, step: 1 }}
            // sx={{ mb: 3 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <TextField
            label="Minimum Quantity"
            name="minimumQty"
            type="number"
            value={data?.formData?.minimumQty || ""}
            onChange={(e) => handleInputChange("minimumQty", e.target.value)}
            error={!!formError?.minimumQty}
            helperText={formError?.minimumQty}
            fullWidth
            required
            margin="normal"
            inputProps={{ min: 0, step: 1 }}
            sx={{ mb: 3 }}
          />
          <FormControl
            fullWidth
            required
            error={!!formError?.planType}
            sx={{ mb: 2 }}
          >
            <InputLabel>Plan Type</InputLabel>
            <Select
              value={data?.formData?.planType || ""}
              label="planType"
              onChange={(e) => handleInputChange("planType", e.target.value)}
              disabled={type === "edit" && true}
            >
              <MenuItem value="complimentary">Complimentary</MenuItem>
              <MenuItem value="fee-based">Fee Based</MenuItem>
            </Select>
            {formError?.planType && (
              <FormHelperText>{formError.planType}</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth required error={!!formError?.frequency}>
            <InputLabel>Frequency</InputLabel>
            <Select
              value={data?.formData?.frequency || ""}
              label="Frequency"
              onChange={(e) => handleInputChange("frequency", e.target.value)}
              disabled={type === "edit" && true}
            >
              <MenuItem value="monthly">Monthly</MenuItem>
              <MenuItem value="yearly">Yearly</MenuItem>
            </Select>
            {formError?.frequency && (
              <FormHelperText>{formError.frequency}</FormHelperText>
            )}
          </FormControl>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              sx={{ color: "red" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isDisabled}
              sx={{ ml: 2 }}
            >
              {type === "add" ? "Add" : "Update"}
              {loading?.isLoading && loading?.type === "submit" && (
                <CircularProgress
                  size={24}
                  sx={{ color: "white", marginRight: 0, marginLeft: 0.5 }}
                />
              )}
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default ModalFormPlan;
